
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AssigneeReference } from 'ah-api-gateways';
import { getPhoneNumber } from 'ah-common-lib/src/helpers/calls';

@Component
export default class ClientAssigneeBlock extends Vue {
  @Prop({ required: true }) assigneeRef!: AssigneeReference;

  getPhoneNumber = getPhoneNumber;
}
